import React from 'react';

import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';

import { createBrowserHistory } from 'history';

import { Router, Route, Switch, Redirect } from 'react-router-dom';

import AuthLayout from 'orden_express/layouts/Auth.jsx'

import AdminLayout from 'orden_express/layouts/Admin.jsx';

import ClientLayout from 'orden_express/layouts/Client.jsx';

import store from 'rootReducer';

import 'bootstrap/dist/css/bootstrap.css';

import 'assets/scss/paper-dashboard.scss';

//import 'prevent-pull-refresh';

export const hist = createBrowserHistory();
/*
const ws=new WebSocket('ws://servidor.com/ws');

//ws.send("Hola");
//ws.close();

ws.onopen = () =>{
  console.info("WS Open","Open")
}

ws.onmessage = (e) =>{
  const msg=JSON.parse(e.data);
  console.info("WS Mensaje",e)
}

ws.onerror = (e) =>{
  console.info("WS Error",e)
}

ws.onclose = (e) =>{
  console.info("WS Close",e);
}*/
//********************************************************
//VER EN EL INDEX.HTML LA PROTECCIÓN CONTRA PULL-TO-REFRESH 
//esto sucede cuando se tira hacia abajo en la pantalla y esta se refresca
//esto solo ocurre con el navegdaor google chrome
//*********************************************************
ReactDOM.render(
  <Provider store={store}>
    <Router history={hist}>
      <Switch>
        <Route path='/auth' render={props => <AuthLayout {...props} />} />
        <Route path='/admin' render={props => <AdminLayout {...props} />} />
        <Route path='/client' render={props => <ClientLayout {...props} />} />
        <Redirect from='/' to='/auth/login' />
      </Switch>
    </Router>
  </Provider>,
  document.getElementById('root'),
);